export default "__VITE_ASSET__jYHPNZzN__"